import { Boxes, Mail, Phone, MessageCircle } from "lucide-react";

const PHONE_RAW = "+5531988557694";
const EMAIL = "samuelmorais@gmail.com";
const EMAIL_LINK = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
  EMAIL
)}&su=${encodeURIComponent("Contato pelo site AnimaSoftware")}&body=${encodeURIComponent(
  "Olá, gostaria de falar sobre um projeto."
)}`;

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#080808] px-5 sm:px-8 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <a href="#top" className="inline-flex items-center gap-2">
              <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-[#FF6B00] to-[#00FF66]">
                <Boxes className="h-4 w-4 text-black" strokeWidth={2.5} />
              </span>
              <span className="font-[Unbounded] text-lg font-bold tracking-tight">
                Anima<span className="text-[#FF6B00]">Software</span>
              </span>
            </a>
            <p className="mt-5 text-sm text-gray-400 leading-relaxed max-w-md">
              A 3D software studio engineering high-performance real-time
              experiences, immersive XR products and custom 3D systems for
              ambitious brands worldwide.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href={EMAIL_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-email"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 hover:border-[#FF6B00]/40 hover:bg-white/5 transition-all"
                aria-label="Email"
              >
                <Mail className="h-4 w-4" />
              </a>
              <a
                href={`tel:${PHONE_RAW}`}
                data-testid="footer-phone"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 hover:border-[#FF6B00]/40 hover:bg-white/5 transition-all"
                aria-label="Call"
              >
                <Phone className="h-4 w-4" />
              </a>
              <a
                href={`https://wa.me/${PHONE_RAW.replace("+", "")}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 hover:border-[#00FF66]/40 hover:bg-white/5 transition-all"
                aria-label="WhatsApp"
              >
                <MessageCircle className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-gray-500 mb-4">
              Studio
            </div>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Belo Horizonte, MG, Brazil</li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.25em] text-gray-500 mb-4">
              Navigate
            </div>
            <ul className="grid grid-cols-2 gap-2 text-sm text-gray-300">
              {[
                ["About", "#about"],
                ["Services", "#services"],
                ["Why Us", "#differentials"],
                ["Reviews", "#reviews"],
                ["Contact", "#contact"],
                ["Get a Quote", "#contact"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="hover:text-white transition-colors"
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-gray-500">
            Copyright {new Date().getFullYear()} AnimaSoftware. All rights reserved.
          </p>
          <p className="text-xs text-gray-500">
            Bringing ideas to life in 3D - Belo Horizonte, MG, Brazil.
          </p>
        </div>
      </div>
    </footer>
  );
}
